import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private http = inject(HttpClient);
  private router = inject(Router);
  readonly base = environment.apiBaseUrl;

  async get<T = any>(path: string): Promise<T> {
    try {
      const res = await firstValueFrom(this.http.get<any>(`${this.base}${path}`));
      if (!res?.success) { this.router.navigate(['/error']); return null as T; }
      return res.result as T;
    } catch (err: any) {
      if (err?.status !== 401) this.router.navigate(['/error']);
      throw err;
    }
  }

  async post<T = any>(path: string, body: any = {}): Promise<T> {
    try {
      const res = await firstValueFrom(this.http.post<any>(`${this.base}${path}`, body));
      if (!res?.success) { this.router.navigate(['/error']); return null as T; }
      return res.result as T;
    } catch (err: any) {
      if (err?.status !== 401) this.router.navigate(['/error']);
      throw err;
    }
  }

  getRaw<T = any>(path: string) { return this.http.get<T>(`${this.base}${path}`); }
  postRaw<T = any>(path: string, body: any = {}) { return this.http.post<T>(`${this.base}${path}`, body); }
  getHttp() { return this.http; }
  getRouter() { return this.router; }
}
